export default "__VITE_ASSET__NYYevRyp__"